// src/utils/url.js
import { uiLanguage } from './assessmentLanguage';

/**
 * 解析 URL 参数
 * @param {string} key - 参数名
 * @param {string} defaultValue - 默认值
 * @returns {string} 参数值
 */
export const getQueryParam = (key, defaultValue = '') => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(key) || defaultValue;
};

/**
 * 获取所有通用的业务参数
 * @returns {Object} 包含常用业务参数的对象
 */
export const getCommonParams = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return {
    useruuid: searchParams.get('useruuid') || '',
    defaultLang: searchParams.get('assessment_language')
      ? uiLanguage(searchParams.get('assessment_language')) : (searchParams.get('defaultLang') || ''),
    assessment_language: searchParams.get('assessment_language') || '',
    report_language: searchParams.get('report_language') || '',
    question_bank_version: searchParams.get('question_bank_version') || '',
    question_bank_checksum: searchParams.get('question_bank_checksum') || '',
    scoring_version: searchParams.get('scoring_version') || '',
    evaluation_uuid: searchParams.get('evaluation_uuid') || '',
    companyCode: searchParams.get('companyCode') || '',
    Job_NID: searchParams.get('Job_NID') || '',
    User_NID: searchParams.get('User_NID') || '',
    codeType: searchParams.get('codeType') || '',
    evaluation_type: searchParams.get('evaluation_type') || '',
    isNewCandidate: searchParams.get('is_new') === 'true',
  };
};
